import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { createShallowStore, createStore } from '@frontend/store';

export type ExtendedAppointment = Appointment & {
  // used for v3 only
  referenceId?: string;
  appointmentTypeId?: string;
  isOverlapping?: boolean;
  displayOptions?: {
    primaryColor?: string;
    backgroundColor?: string;
    textColor?: string;
  };
};

type AppointmentsStoreType = {
  appointments: ExtendedAppointment[] | undefined;
  setAppointments: (data: ExtendedAppointment[]) => void;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  refreshAppointments: () => void;
  setRefreshAppointments: (refreshAppointmentsMethod: () => void) => void;
};

const useAppointmentsStore = createStore<AppointmentsStoreType>(
  (set) => ({
    selectedDate: '',
    appointments: [],
    refreshAppointments: () => {},
    setSelectedDate: (date: string) => {
      set((state) => {
        state.selectedDate = date;
      });
    },
    setAppointments: (data) => {
      set((state) => {
        state.appointments = data;
      });
    },
    setRefreshAppointments: (refreshAppointmentsMethod) => {
      set((state) => {
        state.refreshAppointments = refreshAppointmentsMethod;
      });
    },
  }),
  { name: 'appointments' }
);

// TODO: REMOVE THIS (CAREFULLY AFTER VALIDATING) AS WE CAN USE new V2QueriesData HOOK INSTEAD
export const useAppointmentsInfoShallowStore = createShallowStore<AppointmentsStoreType>(useAppointmentsStore);
